import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationCaseDecisionTypesPresenter } from "../../presenter/OrganisationCaseDecisionTypesPresenter";
import OrganisationCaseDecisionTypeGrid from "../components/OrganisationCaseDecisionTypeGrid";

export interface Props extends PageProps {}
export interface State extends IOrganisationCaseDecisionTypesPresenter {}

export default class OrganisationCaseDecisionTypesPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      onChangeAddElementsModalVisible,
      organisationCaseDecisionTypes,
      organisationId,
      addCaseDecisionTypeToOrganisation,
      onChangeAddTypesToOrganisationModalVisible,
      setOrganisationCaseDecisionTypeData,
      caseDecisionTypes,
      assignTypesToOrganisationModalVisible,
      modalVisible,
      currentCaseDecisionTypeId,
      organisationIndexCategories,
      caseDecisionTypeIndexCategories,
      removeOrganisationCaseLawDocumentType,
      addCaseDecisionTypeIndexCategories
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        <Spin spinning={this.state.loaders.organisationCaseDecisionType}>
          <OrganisationCaseDecisionTypeGrid
            removeOrganisationCaseLawDocumentType={
              removeOrganisationCaseLawDocumentType
            }
            addCaseDecisionTypeIndexCategories={
              addCaseDecisionTypeIndexCategories
            }
            organisationCaseDecisionTypes={organisationCaseDecisionTypes}
            organisationId={organisationId}
            translate={translate}
            currentCaseDecisionTypeId={currentCaseDecisionTypeId}
            modalVisible={modalVisible}
            caseDecisionTypeIndexCategories={caseDecisionTypeIndexCategories}
            organisationIndexCategories={organisationIndexCategories}
            onChangeAddElementsModalVisible={onChangeAddElementsModalVisible}
            addCaseDecisionTypeToOrganisation={
              addCaseDecisionTypeToOrganisation
            }
            onChangeAddTypesToOrganisationModalVisible={
              onChangeAddTypesToOrganisationModalVisible
            }
            assignTypesToOrganisationModalVisible={
              assignTypesToOrganisationModalVisible
            }
            setOrganisationCaseDecisionTypeData={
              setOrganisationCaseDecisionTypeData
            }
            caseDecisionTypes={caseDecisionTypes}
          />
        </Spin>
      </Page>
    );
  }
}
